import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IUser } from '../../../shared/models/user.model';
import { EventsService, UtilService, VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-timeline-v2',
  templateUrl: './timeline-v2.component.html',
  styleUrls: ['./timeline-v2.component.scss']
})
export class TimelineV2Component implements OnInit {

  @Input() fundraiser;
  @Input() userData: IUser;
  params;
  states = [
    { label: 'Contributions' },
    { label: 'You Contributed' },
    { label: 'Attempted Contribution' },
    { label: 'You viewed campaign' },
  ];

  constructor(
    public utilService: UtilService,
    public eventsService: EventsService,
    public variablesService: VariablesService,
    private actRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.actRoute.queryParams.subscribe(res => {
      this.params = res;
    });
  }

  helpMore() {
    this.utilService.scrollIntoViewSmoothly('donation-form', 180);
    this.eventsService.sendSystemEvent({
      eventName: 'update_page_help_more',
      info_3: this.variablesService.campaignType,
      page_name: this.variablesService.pageName
    }).subscribe(_ => _);
  }

}
